import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from '../locales/zh.js';
import en from '../locales/en.js';

Vue.use(VueI18n);

// Get the saved language from localStorage, or default to Chinese
const savedLocale = localStorage.getItem('locale') || 'zh';

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    zh,
    en
  }
});

export default i18n; 